import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth-guard/auth-guard';
import { VerticalLayoutComponent } from '../layout/vertical';
import { HorizontalLayoutComponent } from '../layout/horizontal';
import { PublicLayoutComponent } from '../layout/public';
import { Page404Component } from '../pages/page-404';
import { MainPageComponentnt } from '../pages/main';
import { PageSignInComponent } from '../pages/sign-in';
import { ForgotPasswordComponent } from '../pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../pages/reset-password/reset-password.component';
import { BasePageComponent } from '../pages/base-page';
import { GeustComponent } from '../pages/guest/guest-page';
import { FoodMenuComponent } from '../pages//guest/food-menu';
import { RestoPageComponent } from '../pages/resto-page/resto-page.component';
import { OrderMenuComponent } from '../pages/guest/order-menu';
import { OrderListComponent } from '../pages/guest/order-list';
import { PageSignUpComponent } from '../pages/sign-up';
import { GuestGuard } from '../auth-guard/guest-guard';
// import { CartComponent } from '../pages/bottomnav/cart/cart.component';
import { MenuComponent } from '../layout/components/menu';

import { ProfileComponent } from '../pages/guest/profile/profile.component';
import { AllergyratingComponent } from '../pages/guest/allergyrating/allergyrating.component';
import { AllorderreviewComponent } from '../pages/guest/allorderreview/allorderreview.component';
import { OrderDetailsComponent } from '../pages/guest/order-details/order-details.component';
import { PrivacyPolicyComponent } from '../pages/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from '../pages/terms-condition/terms-condition.component';
import { UsersrestoListComponent } from '../pages/guest/usersresto-list';
import { EditProfileComponent } from '../pages/guest/edit-profile/edit-profile.component';
import { MyfriendsComponent } from '../pages/guest/myfriends';
import { SharefriendsComponent } from '../pages/guest/sharefriends';
import { UserprofileComponent } from '../pages/guest/userprofile/userprofile.component';
import { EditTasteprofileComponent } from '../pages/guest/edit-tasteprofile';
import { MypreferenceComponent } from '../pages/guest/mypreference';
import { UserLocationComponent } from '../pages/guest/user-location/user-location.component';
import { AggregratorComponent } from '../pages/guest/aggregrator/aggregrator.component';
import { UserGuestLocationComponent } from '../pages/guest/user-guest-location/user-guest-location.component';
import { PaymentSucessComponent } from '../pages/guest/payment-sucess/payment-sucess.component';
import { PaymentFailureComponent } from '../pages/guest/payment-failure/payment-failure.component';
import { SampleMenuComponent } from '../pages/guest/sample-menu/sample-menu.component';

const VERTICAL_ROUTES: Routes = [
  // { path: 'main', component: MainPageComponentnt },RegisterFormComponent

  { path: 'choose-preference', component: GeustComponent },
  { path: 'food-menu', component: FoodMenuComponent },
  { path: 'order-menu', component: OrderMenuComponent },
  { path: 'aggregator', component: UsersrestoListComponent },
  { path: 'myOrders', component: OrderListComponent },
  { path: 'post-review', component: OrderDetailsComponent },
  { path: 'Usermenu', component: MenuComponent },
  { path: 'profile', component: ProfileComponent },
  { path: 'userprofile', component: UserprofileComponent },
  { path: 'edit-profile', component: EditProfileComponent },
  { path: 'allergy-ratings', component: AllergyratingComponent },
  { path: 'taste-ratings', component: AllorderreviewComponent },
  { path: 'friends', component: MyfriendsComponent },
  // {path:'sharefriends',component:SharefriendsComponent}, this component is used as change location
  { path: 'change-location', component: SharefriendsComponent },
  { path: 'edit-tasteprofile', component: EditTasteprofileComponent },
  { path: 'preference', component: MypreferenceComponent },
  { path: 'user-location', component: UserLocationComponent },
  { path: 'userLocations', component: UserLocationComponent },
  { path: 'UserGuestLocation', component: UserGuestLocationComponent },
  // {path:'aggregator',component:AggregratorComponent},
  { path: '**', component: Page404Component },


];

const PUBLIC_ROUTES: Routes = [
  { path: 'sign-in', component: PageSignInComponent },
  { path: 'sign-up', component: PageSignUpComponent },
  { path: 'forgot', component: ForgotPasswordComponent },
  { path: 'resetPassword', component: ResetPasswordComponent },
  { path: 'privacy', component: PrivacyPolicyComponent },
  { path: 'terms', component: TermsConditionComponent },
  { path: 'main', component: MainPageComponentnt },
  { path: 'resto', component: RestoPageComponent },
  { path: 'guest-user', component: GeustComponent },
  { path: 'food-menu-guest', component: FoodMenuComponent },
  { path: 'food-menu', component: FoodMenuComponent },
  { path: 'sample-menu', component: SampleMenuComponent },
  { path: 'order-menu-guest', component: OrderMenuComponent },
  { path: 'order-menu', component: OrderMenuComponent },
  { path: 'myOrders', component: OrderListComponent },
  { path: 'order-details', component: OrderDetailsComponent },
  { path: 'usermenu', component: MenuComponent },
  { path: 'profile', component: ProfileComponent },
  { path: 'guestallergensreview', component: AllergyratingComponent },
  { path: 'guestallreviews', component: AllorderreviewComponent },
  { path: 'user-location', component: UserLocationComponent },
  { path: 'aggregator', component: AggregratorComponent },
  { path: 'choose-preference', component: GeustComponent },
  { path: '**', component: Page404Component }

];

const PAYMENT_ROUTES: Routes = [ 
  { path : 'paymentSuccess',component : PaymentSucessComponent },
  { path :'paymentFailure' , component : PaymentFailureComponent}
]

export const ROUTES: Routes = [
  {
    path: '',
    redirectTo: '/public/resto',
    pathMatch: 'full'
  },
  {
    path: 'vertical',
    component: VerticalLayoutComponent,
    children: VERTICAL_ROUTES,
  },
  {
    path: 'horizontal',
    component: HorizontalLayoutComponent,
    children: VERTICAL_ROUTES,
    canActivate: [AuthGuard]
  },
  {
    path: 'payment',
    children: PAYMENT_ROUTES,
    canActivate: [AuthGuard]
  },
  {
    path: 'public',
    component: PublicLayoutComponent,
    // canActivate: [GuestGuard],
    children: PUBLIC_ROUTES
  },
  {
    path: '**',
    component: VerticalLayoutComponent,
    children: VERTICAL_ROUTES
  }
];

@NgModule({
  imports: [

  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class RoutingModule { }
